import { FastField } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import { useTranslation } from 'react-i18next';
import { Row, Col, Modal } from 'react-bootstrap';
import { useState } from 'react';
import KTBSButton, { KTBSButtonColor, KTBSButtonSize, KTBSButtonType } from 'general/components/OtherKeenComponents/KTBSButton';

function PackageCommissionView({
    formikProps,
    commissionRateGroup,
}) {
    const { t } = useTranslation();

    const handleAddPackageCommission = (values, setFieldValue) => {
        const nextId = values.packageCommission[values.packageCommission.length - 1].id + 1;
        const updatedPackageCommission = [
            ...values.packageCommission,
            {
                id: nextId,
                revenue: 0,
                discount: 0,
            },
        ];

        setFieldValue('packageCommission', updatedPackageCommission);
    };

    const handleDeletePackageCommission = (id, values, setFieldValue) => {
        const updatedPackageCommission = values.packageCommission.filter((bonus) => bonus.id !== id);
        if (updatedPackageCommission.length === 0) {
            setFieldValue('packageCommission', [{ id: 0, revenue: 0, discount: 0 }]);
        } else {
            setFieldValue('packageCommission', updatedPackageCommission);
        }
    };

    return (
        <Row>
            <Col md={12}>
                <Modal.Title className="mb-3">
                    <span
                        className="font-weight-bolder"
                        style={{ fontSize: 18, color: AppColors.gray[900] }}
                    >
                        Hoa hồng bán gói đầu tư HTKD
                    </span>
                </Modal.Title>
            </Col>
            {commissionRateGroup && (
                <Col md={4} className="pr-0">
                    <KTFormGroup
                        label={
                            <span
                                className="font-weight-boldest"
                                style={{
                                    fontSize: 13,
                                    color: AppColors.gray[800],
                                }}
                            >
                                {t('Tỷ lệ hoa hồng')}
                            </span>
                        }
                        inputName={`packageCommission[0].discount`}
                        additionalClassName=" mb-3"
                        inputElement={
                            <FastField name={`packageCommission[0].discount`}>
                                {({ field, form, meta }) => {
                                    return (
                                        <KTFormInput
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => {
                                                form.setFieldValue(field.name, value);
                                            }}
                                            onBlur={() => {
                                                form.setFieldTouched(field.name, true);
                                            }}
                                            enableCheckValid
                                            type={KTFormInputType.number}
                                            placeholder={'Nhập số'}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            unit="%"
                                        />
                                    );
                                }}
                            </FastField>
                        }
                    // isRequired={true}
                    />
                </Col>
            )}
            {formikProps.values.packageCommission?.slice(1)?.map((discount, index) => (
                <div key={index + 1}>
                    <Row>
                        <Col md={7} className="pr-0" style={{ paddingLeft: 15 }}>
                            <KTFormGroup
                                label={
                                    <span
                                        className="font-weight-boldest"
                                        style={{
                                            fontSize: 13,
                                            color: AppColors.gray[800],
                                        }}
                                    >
                                        {t('Doanh thu đạt mức')}{' '}
                                    </span>
                                }
                                inputName={`packageCommission[${index + 1}].revenue`}
                                additionalClassName="mb-3"
                                inputElement={
                                    <FastField name={`packageCommission[${index + 1}].revenue`}>
                                        {({ field, form, meta }) => {
                                            return (
                                                <KTFormInput
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={(value) => {
                                                        form.setFieldValue(field.name, value);
                                                    }}
                                                    onBlur={() => {
                                                        form.setFieldTouched(field.name, true);
                                                    }}
                                                    enableCheckValid
                                                    type={KTFormInputType.currency}
                                                    placeholder={'Nhập số'}
                                                    isValid={_.isEmpty(meta.error)}
                                                    isTouched={meta.touched}
                                                    feedbackText={meta.error}
                                                />
                                            );
                                        }}
                                    </FastField>
                                }
                            // isRequired={true}
                            />
                        </Col>

                        <Col md={5} className="pr-5">
                            <div className="d-flex gap-3 align-items-center">
                                <KTFormGroup
                                    label={
                                        <span
                                            className="font-weight-boldest"
                                            style={{
                                                fontSize: 13,
                                                color: AppColors.gray[800],
                                            }}
                                        >
                                            {t('Thưởng thêm')}
                                        </span>
                                    }
                                    inputName={`packageCommission[${index + 1}].discount`}
                                    additionalClassName=" mb-3 flex-grow-1"
                                    inputElement={
                                        <FastField name={`packageCommission[${index + 1}].discount`}>
                                            {({ field, form, meta }) => {
                                                return (
                                                    <KTFormInput
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={(value) => {
                                                            form.setFieldValue(field.name, value);
                                                        }}
                                                        onBlur={() => {
                                                            form.setFieldTouched(field.name, true);
                                                        }}
                                                        enableCheckValid
                                                        type={KTFormInputType.number}
                                                        placeholder={'Nhập số'}
                                                        isValid={_.isEmpty(meta.error)}
                                                        isTouched={meta.touched}
                                                        feedbackText={meta.error}
                                                        unit="%"
                                                    />
                                                );
                                            }}
                                        </FastField>
                                    }
                                // isRequired={true}
                                />
                                <KTBSButton
                                    size={KTBSButtonSize.medium}
                                    color={KTBSButtonColor.secondary}
                                    type={KTBSButtonType.default}
                                    iconElement={
                                        <i
                                            className="fa-regular fa-trash-can"
                                            style={{ fontSize: 15 }}
                                        />
                                    }
                                    iconOnly
                                    borderRadius={5}
                                    onPress={() =>
                                        handleDeletePackageCommission(
                                            discount.id,
                                            formikProps.values,
                                            formikProps.setFieldValue
                                        )
                                    }
                                    additionalClassName="mt-4"
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            ))}
            <Row>
                <Col
                    md={1}
                    style={{ paddingLeft: 15 }}
                    className="d-flex align-items-center mb-4 mt-1"
                >
                    <KTBSButton
                        title={t('add')}
                        size={KTBSButtonSize.medium}
                        color={KTBSButtonColor.secondary}
                        type={KTBSButtonType.default}
                        iconElement={
                            <i className="fa-regular fa-plus" style={{ fontSize: 15 }} />
                        }
                        additionalClassName="font-weight-bolder py-3 px-6"
                        borderRadius={5}
                        onPress={() =>
                            handleAddPackageCommission(
                                formikProps.values,
                                formikProps.setFieldValue
                            )
                        }
                        buttonTitleColor={AppColors.gray[800]}
                        buttonTitleFontWeight={600}
                        buttonTitleFontSize={14}
                    />
                </Col>
            </Row>
        </Row>
    )
}

export default PackageCommissionView;